const { isArray, from } = Array;

export { from, isArray };
